module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrapper"
  }, [_c('img', {
    staticClass: "wave",
    attrs: {
      "src": require("../assets/img/header-top-wave.png")
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.receive),
      expression: "receive"
    }],
    staticClass: "receive-lock",
    on: {
      "click": function($event) {
        _vm.receive = false
      }
    }
  }, [_vm._v("......")]), _vm._v(" "), (_vm.PP) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.receive),
      expression: "receive"
    }],
    staticClass: "receive-container"
  }, [_c('div', [_c('img', {
    staticClass: "adorable",
    attrs: {
      "src": _vm.avatar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "qrid-container"
  }, [_c('div', [_vm._v(_vm._s(_vm.email))]), _vm._v(" "), _c('div', {
    staticClass: "qr"
  }, [_c('qriously', {
    attrs: {
      "value": _vm.PP,
      "size": 260
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "100%",
      "margin-left": "10px"
    },
    attrs: {
      "for": "account-id"
    }
  }, [_vm._v("Account Id")]), _vm._v(" "), _c('div', {
    staticClass: "publickey"
  }, [_c('div', {
    staticClass: "account-id-wrapper"
  }, [_c('el-input', {
    staticClass: "account-id",
    model: {
      value: (_vm.PP),
      callback: function($$v) {
        _vm.PP = $$v
      },
      expression: "PP"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.PP),
      expression: "PP",
      arg: "copy"
    }],
    staticClass: "copy",
    attrs: {
      "slot": "append",
      "type": "success"
    },
    on: {
      "click": _vm.copy
    },
    slot: "append"
  }, [_c('clipboard-icon')], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "home"
  }, [_c('img', {
    staticClass: "logo_lt",
    attrs: {
      "src": require("../assets/img/logo-luxtag.png")
    },
    on: {
      "click": _vm.logoClicked
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "re-note"
  }, [_vm._v("Have the sender scan this QRCode "), _c('br'), _vm._v(" or send your Account Id")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d2eaff0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 253
// module chunks = 11